import { memo } from "react";

function Footer() {
  const appVersion = import.meta.env.VITE_APP_VERSION;
  return (
      <footer className="w-full flex justify-end items-center h-4 text-xs footer-style z-1000">
          <p >Version : {appVersion}</p>
      </footer>
  );
}

export default memo(Footer);
